<template>
    <div class="tab-pane fade show active" id="pricing" role="tabpanel" aria-labelledby="pricing-tab">
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="row pb-2">
                <div class="col-md-6">
                    <h3 class="pt-2 mb-2">{{title}} Price Records</h3>
                    <p class="text-muted mb-2 text-xs max-w-para" v-if="title !== 'Expired'">
                        This view allows for creation and linking of price records to the current product.
                        Price records can be set on a chronological basis. Price records require the <strong>
                        Price Base</strong> value to be set. Each publication channel is tied to a single price base
                        value to allow for a variety of pricing scenarios. To learn more <a href="https://jasperstudioshelp.zendesk.com/hc/en-us/articles/360026515554-Understanding-Pricing">
                        click here</a>.
                    </p>
                </div>
                <div class="col-md-6 text-right">
                    <a v-if="$parent.permissionAllowed('manage_pricing') && title !== 'Expired'" href="Javascript:void(0)" data-toggle="collapse" data-target="#add_price_record" class="btn btn-primary">Create Price</a>
                </div>
            </div>
            <div id="add_price_record" class="collapse border p-4 mb-3" v-if="$parent.permissionAllowed('manage_pricing')">
                <input-loader :fields="priceRecordsFormData.items.groupItems" ref="priceInputLoader"></input-loader>
                <div class="row pb-2">
                    <div class="col-md-12 text-right" v-if="$parent.permissionAllowed('manage_pricing')">
                        <button :disabled="uiStates.formPricesBlank || uiStates.formBaseBlank" type="button" class="btn btn-primary" @click="createPriceRecord()">Save</button>
                        <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#add_price_record">Close</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <table-search :placeholder="`Search ${this.title} Price Records`"></table-search>
                </div>
                <div class="col-md-8">
                    <pagination-limit :per-page="perPage"></pagination-limit>
                </div>
            </div>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                <table class="table table-middle table-minimal">
                    <thead>
                        <tr>
                            <th>Base</th>
                            <th class="text-right">{{priceLabels.msrp}}</th>
                            <th class="text-right">{{priceLabels.map}}</th>
                            <th class="text-right">{{priceLabels.cost}}</th>
                            <th class="text-right">{{priceLabels.sellPrice}}</th>
                            <th>Start ({{ clientTimezone ? clientTimezone : 'UTC' }})</th>
                            <th>End ({{ clientTimezone ? clientTimezone : 'UTC' }})</th>
                            <th v-if="$parent.permissionAllowed('manage_pricing')"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="price in prices.data" v-bind:key="price.id">
                            <td>
                                {{ price.base }}
                            </td>
                            <td class="text-right">
                                {{ price.msrp }}
                            </td>
                            <td class="text-right">
                                {{ price.map }}
                            </td>
                            <td class="text-right">
                                {{ price.cost }}
                            </td>
                            <td class="text-right">
                                {{ price.sell_price }}
                            </td>
                            <td>
                                {{ price.from }}
                            </td>
                            <td>
                                {{ price.to }}
                            </td>
                            <td v-if="$parent.permissionAllowed('manage_pricing')">
                                <delete-toggle v-if="showDelete(price.to)" label="Expire Price" @remove="disablePriceRecord(price.id)"></delete-toggle>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row mt-4">
                    <div class="col-md-4">
                        <pagination-info
                            :paginationInfo="prices.meta"
                            ref="paginationInfo"
                        >
                        </pagination-info>
                    </div>
                    <div class="col-md-8">
                        <pagination
                            :pagination="prices.meta"
                            @paginate="getPrices()"
                            :offset="4"
                        ></pagination>
                    </div>
                </div>
            </div>
            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
    </div>
</template>
<script>

var base_url = window.location.protocol + "//" + window.location.host
import axios from 'axios'
import moment from 'moment-timezone';
import Pagination from '../generic/tables/pagination.vue';
import PaginationInfo from '../generic/tables/pagination-info.vue';
import PaginationLimit from '../generic/tables/pagination-limit.vue';
import TableSearch from '../generic/tables/search.vue';
import InputLoader from '../form/form-loader.vue';
import ConfirmDeletion from '../generic/delete-toggle.vue';

export default {
    name: 'product-pricing-v2',
    components: {
        'input-loader' : InputLoader,
        'pagination' : Pagination,
        'pagination-info' : PaginationInfo,
        'pagination-limit' : PaginationLimit,
        'table-search' : TableSearch,
        'delete-toggle' : ConfirmDeletion
    },
    props: {
        title : String,
        endpoint : String
    },
    data() {
        return {
            perPage: 10,
            query: '',
            loading: true,
            moment: moment,
            priceRecordsFormData: {
                items: {
                    groupingName: 'Price Records',
                    groupItems: [
                        {
                            "name": "msrp",
                            "label": dataObject.priceLabels.msrp,
                            "type": "text",
                            "isPriceRecord":true,
                            "column": "col-md-6",
                            "value": null,
                            "options": [],
                        },
                        {
                            "name": "map",
                            "label": dataObject.priceLabels.map,
                            "type": "text",
                            "isPriceRecord":true,
                            "column": "col-md-6",
                            "value": null,
                            "options": []
                        },
                        {
                            "name": "sell_price",
                            "label": dataObject.priceLabels.sellPrice,
                            "type": "text",
                            "isPriceRecord":true,
                            "column": "col-md-6",
                            "value": null,
                            "options": []
                        },
                        {
                            "name": "cost",
                            "label": dataObject.priceLabels.cost,
                            "type": "text",
                            "isPriceRecord":true,
                            "column": "col-md-6",
                            "value": null,
                            "options": []
                        },
                        {
                            "name": "from",
                            "label": "Start Date (UTC)",
                            "required": false,
                            "type": "datetime",
                            "isPriceRecord":false,
                            "column": "col-md-6",
                            "value": null,
                            "options": []
                        },
                        {
                            "name": "to",
                            "label": "End Date (UTC)",
                            "required": false,
                            "type": "datetime",
                            "isPriceRecord":false,
                            "column": "col-md-6",
                            "value": null,
                            "options": []
                        },
                        {
                            "name": "base",
                            "label": "Base",
                            "required": true,
                            "type": "text",
                            "isPriceRecord":false,
                            "column": "col-md-6",
                            "value": null,
                            "options": []
                        },
                    ]
                }
            },
            priceLabels: dataObject.priceLabels,
            prices: {
                meta: {
                    current_page: 1,
                    from: 1,
                    to: 1,
                    total: 0
                }
            },
            uiStates: {
                errorMessage: null,
                showLoading: true,
                formPricesBlank: true,
                formBaseBlank: true,
                activeModal: ''
            },
            message: '',
            confirmDelete:{
                transitionValue: 'slide',
                isActive: false,
                id: null
            },
            calendarButtonIcon: 'fa fa-calendar',
            inputClass: 'form-control',
            clientTimezone: this.$parent.clientTimezone
        }
    },
    mounted() {
        this.$events.$on('per-page', eventData => this.doVisibleSet(eventData));
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset())
    },
    created() {
        this.getPrices();
    },
    watch: {
        'priceRecordsFormData.items.groupItems': {
            handler: function (val) {
                this.isOnePriceFilled();
            },
            deep: true
        },
        'title': {
            handler: function(val) {
                this.getPrices();
            }
        }
    },
    methods: {
        createPriceRecord() {
            this.loading = true;
            let app = this;
            axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/price_records', {
                'priceRecordsFormData' : this.priceRecordsFormData
            })
            .then(function(response){
                app.collapseForm();
                app.clearFormData();
                app.$parent.alert.status = "alert-success";
                app.$parent.alert.message = "Price record has been created";
                app.loading = false;
                this.getPrices();
            }.bind(this))
            .catch(function(error) {
                app.loading = false;
                app.$parent.alert.status = "alert-danger";
                app.$parent.alert.message = error.response.data.message ? error.response.data.message.join(' ') : 'There has been an issue.';
            }.bind(this));
        },
        clearFormData() {
            this.priceRecordsFormData.items.groupItems.map(x => x.value = null);
            this.uiStates.formPricesBlank = true;
            this.uiStates.formBaseBlank = true;
            this.$refs.priceInputLoader.clearDatetimePicker();
        },
        getPrices() {
            this.loading = true;
            axios.get(`${base_url}/pimapi/products/${this.$parent.product.info.id}/${this.endpoint}?page=${this.prices.meta.current_page}&per_page=${this.perPage}&query=${this.query}`)
            .then(function(response) {
                this.$refs.paginationInfo.setPaginationData(response.data.meta);
                this.prices = response.data;
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                this.loading = false;
            }.bind(this));
        },
        showDelete(priceTo) {
            return !priceTo || !moment().isAfter(priceTo);
        },
        doVisibleSet(perPageValue) {
            this.perPage = perPageValue;
            this.$nextTick(() => this.getPrices());
        },
        onFilterSet(query) {
            this.query = query;
            this.$nextTick( () => this.getPrices());
        },
        onFilterReset() {
            this.query = '';
            this.$nextTick(() => this.getPrices());
        },
        isOnePriceFilled(){
            for(var item of this.priceRecordsFormData.items.groupItems) {
                if (item.isPriceRecord && item.value != null) {
                    if(isNaN(item.value)){
                        this.uiStates.formPricesBlank = true;
                        break;
                    }
                    this.uiStates.formPricesBlank = false;
                    break;
                }
                else{
                    this.uiStates.formPricesBlank = true;
                }
            }
            this.priceRecordsFormData.items.groupItems.forEach(function (item) {
                if (item.name == 'base' && item.value != null) {
                    this.uiStates.formBaseBlank = false;
                }
                else{
                    this.uiStates.formBaseBlank = true;
                }
            }.bind(this));
        },
        disablePriceRecord(id) {
            this.loading = true;
            axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/price_records/' + id + '/disable', [

            ])
            .then(function(response) {
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = "Price record has been disabled"
                this.cancelDeletion();
                this.loading = false;
                setTimeout(() => this.getPrices(), 1000);
            }.bind(this))
            .catch(function(error) {
                this.loading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this));
        },
        collapseForm() {
            $('#add_price_record').collapse('toggle');
        },
        cancelDeletion () {
            this.confirmDelete.isActive = false;
            this.confirmDelete.transitionValue = 'slide'
            this.confirmDelete.id = null;
        },
        confirmDeletion (id) {
            if (this.confirmDelete.isActive == true) {
                this.cancelDeletion()
            }else{
                this.confirmDelete.isActive = true;
                this.confirmDelete.id = id;
                this.confirmDelete.transitionValue = 'slide-reverse'
            }
        }
    }
}
</script>
<style lang="scss">
    @import '~tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css';
</style>
<style lang="scss" scoped>
.slide-reverse-leave-active,
    .slide-reverse-enter-active,
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(-100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(100%, 0);
    }

    .slide-reverse-enter {
      transform: translate(100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-reverse-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(-100%, 0);
    }

    .expand-enter-active,
    .expand-leave-active {
      transition: all 0.2s;
      max-height: 145px;
      margin-bottom: 15px;
    }
    .expand-enter,
    .expand-leave-to
    {
      opacity: 0;
      max-height: 0px;
      margin-bottom: 0;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

    .btn-confirm-delete{
        .btn{
            padding: 11px 8px 9px 8px;
            &:last-child{
                z-index: 10;
                // border-left:1px solid #ff9a9a;
            }
        }
    }
    .btn-start-confirmation{
        width: 100%;
    }
    .btn-confirm-delete {
        width: 100%;
        .btn{
            width: 100%;
        }
    }
    .btn-outline-danger{
        border-color: #AB5755;
        color:#AB5755;

    }
    .action-container{
        position: relative;
        border-left: 1px solid #f5f6fa;
        overflow: hidden;
        background-color: #AB5755;
        border-radius: 2px;
        width: 76px;
        height: 27px;
        .btn-confirm-delete, .btn-start-confirmation{
            position: absolute;
            width: 100%;
            top: 0;
        }
        .btn-start-confirmation{
            padding: 5px 13px;
        }
        .btn {
            font-size: 9px;
        }
    }

</style>
